import Vue from "vue";
import api from "./modules/api";
import AppManager from "./components/AppManager.vue";
import { utils } from "./modules/utils";

// Assigns api functions to vue $api, so hou can do this.$api
Vue.prototype.$api = api;
Vue.config.productionTip = false;

Vue.prototype.$constants = JSON.parse(
  document.getElementById("static-data").dataset.all,
);

// Onesignal notifications
import OneSignalVue from "onesignal-vue";
Vue.use(OneSignalVue);

const mgmt = new Vue({
  el: "#mgmt",
  name: "App Manager App",
  components: { AppManager },
  data() {
    return {
      siloData: utils.get_data(),
    };
  },
  mounted() {
    window.mgmt = this;

    console.log("*** app: APP MOUNTED");

    if (localStorage.getItem("user_id") === null) {
      this.fetchSiloData();
    }

    // ! DO I NEED TO DO THIS TWICE?
    //this.refreshLoginToken();
  },
  /*
    watch: {
        siloData() {
            this.makeSureWereLoggedIn();
        }
    },
    */
  methods: {
    refreshLoginToken() {
      console.log("*** app: refreshing login token");
      setInterval(async () => {
        const baseUrl = window.location.origin + "/wp-json";
        const token = localStorage.getItem("access_token");
        console.log(token);

        if (!token) return;

        console.log("*** app: we have the token");

        try {
          await this.$api.post(`${baseUrl}/jwt-auth/v1/token/validate`);
          console.log("*** app: Token validated");
        } catch (e) {
          console.warn(
            "*** app: Token check failed, will refresh automatically on next request",
          );
        }
      }, 1000 * 60 * 60 * 24); // ping once a day
    },
    async logout() {
      console.log("LOGGING OUT...");

      let data = {
        type: "open",
        message: `User logged out manually.`,
      };
      window.events.postAction(data);

      const token = localStorage.getItem("access_token");
      const baseUrl = window.location.origin + "/wp-json";

      try {
        await this.$api.post(
          `${baseUrl}/custom/v1/logout`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          },
        );
      } catch (e) {
        console.warn("Server logout failed (likely already logged out)", e);
        // fall through — local cleanup still happens below regardless
      }

      // Detach this subscription from the OneSignal External ID so it
      // stops being included in future sends to that user. Without this,
      // repeated test logins/logouts on the same browser leave orphaned
      // subscriptions linked to the same external_id, causing duplicate
      // deliveries.
      if (window.pusher?.$OneSignal) {
        try {
          await window.pusher.$OneSignal.logout();
        } catch (e) {
          console.warn("OneSignal logout failed", e);
        }
      }

      // push_prompt_shown lives in device-scoped localStorage, but the
      // underlying push subscription ownership just changed hands (see
      // the OneSignal.logout() call above) — the next person to log in
      // on this device may be a completely different account with no
      // real subscription of their own yet. Without clearing this, a
      // second user sharing this device would silently never get asked
      // to subscribe at all, since the flag would still read true from
      // the previous account.
      localStorage.removeItem("push_prompt_shown");

      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");

      this.siloData = await utils.fetch_data(0);
      this.$refs.am.appState = "login";

      console.log("YOU ARE NOW LOGGED OUT...");
    },
    // We pass this when the user is logged out by losing a token or something
    async logoutSoft() {
      /*
                window.moduleloader.reset();
                window.topicmenu.close();
                if (window.activecard !== undefined) {
                    window.activecard.close();
                }
                    */

      // Clear local tokens
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");

      // This resets the data to the skeleton data
      //this.siloData = await utils.fetch_data(0);
    },
    async fetchSiloData() {
      console.log("fetching silo data");
      // * Get the ID of the currently logged in user
      const user_id =
        localStorage.getItem("user_id") !== null
          ? localStorage.getItem("user_id")
          : 0;
      //this.siloData = utils.get_data();
      this.siloData = await utils.fetch_data(user_id);
      console.log("SETTING NEW SILO DATA", this.siloData);
    },
  },
  // This needs to be done this way in order to pass props
  template: `<app-manager ref="am" v-bind:siloData="siloData" @logout="logout" @logoutSoft="logoutSoft" @updateSiloOnLogin="fetchSiloData"></app-manager>`,
});


const notifications = new Vue({
  el: "#notifications",
  name: "Notifications",
  beforeMount() {
    this.$OneSignal
      .init({
        // PRODUCTION
        appId: "bf55ddba-d3f9-4e2e-a7d6-806f8a1fe4dd",
        // LOCAL
        //appId: "607bea6a-0546-48e2-8b97-a4c8eec5506b",
        // LOCAL (needed for http)
        //allowLocalhostAsSecureOrigin: true,
        autoPrompt: false,
        serviceWorkerParam: { scope: "/push/onesignal/" },
      })
      .then(() => {
        console.log("********************* one signal loaded");

        // Establish the notifications object
        window.notifications = this.$OneSignal;

        // By default, OneSignal does NOT auto-display a notification
        // while this page/tab is already open — it hands control to us
        // via this event instead. Without a listener here, a push
        // arriving while the app is open silently does nothing, which
        // is why testing showed "works closed, not open" — that's
        // expected default behavior, not a bug. Calling .display()
        // here restores the native banner even while foregrounded; swap
        // this for custom in-app UI instead if that's preferred later.
        this.$OneSignal.Notifications.addEventListener(
          "foregroundWillDisplay",
          (event) => {
            console.log(
              "*** app: notification received while app open",
              event,
            );
            event.notification.display();
          },
        );

        // Tell notification settings that the object is ready
        // TODO: PROBLEM, SOMETIMES THIS FIRES WHEN NOTIFICATION SETTINGS AREN'T AVAILABLE SO THE TOGGLE DOESN'T TURN ON
        window.notificationsSettings.checkNotifications();

        // Set up the change listener
        this.$OneSignal.Notifications.addEventListener(
          "permissionChange",
          this.permissionChangeListener,
        );
        this.$OneSignal.User.PushSubscription.addEventListener(
          "change",
          this.pushSubscriptionChangeListener,
        );
      })
      .catch((reason) => {
        console.log(reason);
      });
  },

  mounted() {
    window.pusher = this;
  },

  methods: {
    // Single place that sets OneSignal's externalId (WP username) and tags
    // the current app version. Reads from the LIVE reactive siloData on
    // window.mgmt, not utils.get_data() — that helper only reads a static
    // snapshot baked into the #silo-data DOM attribute at initial page
    // render, which goes stale the moment a user logs in without a full
    // page reload. That staleness was why externalId only got set
    // correctly on a user's *second* visit.
    identifyUser() {
      const userData = window.mgmt?.siloData?.user;

      if (!userData || userData.id === 0) {
        console.log(
          "app.js: notifications: no logged-in user yet, skipping identify",
        );
        return;
      }

      console.log(
        "app.js: notifications: identifying user",
        userData.username,
      );

      this.$OneSignal.login(userData.username);
    },

    // Separate from identifyUser() so tag-pushing only happens once
    // there's genuinely SETTLED state to report. Pushing tags
    // immediately after triggering promptPush() — before the user has
    // actually responded — was the cause of two bugs: PushManager.vue
    // briefly showing stale derived state, and, more seriously, a race
    // between an early "not yet subscribed" tag push and a later "now
    // subscribed" one, where the early request could complete on
    // OneSignal's servers AFTER the later one and silently overwrite it
    // back to the wrong value. Only call this from places where state is
    // known-settled: a regular landing where nothing is actively
    // changing, or from permissionChangeListener /
    // pushSubscriptionChangeListener once a real decision has been made.
    pushDiagnosticTags() {
      const userData = window.mgmt?.siloData?.user;
      if (!userData || userData.id === 0) return;

      const version = userData.app?.version;

      this.$OneSignal.User.addTags({
        app_version: version || "unknown",
        is_standalone:
          window.matchMedia("(display-mode: standalone)").matches ||
          window.navigator.standalone === true
            ? "true"
            : "false",
        notification_permission:
          typeof Notification !== "undefined"
            ? Notification.permission
            : "unsupported",
        push_supported:
          "serviceWorker" in navigator && "PushManager" in window
            ? "true"
            : "false",
        sw_controlling: navigator.serviceWorker?.controller ? "true" : "false",
        push_prompt_shown:
          localStorage.getItem("push_prompt_shown") === "true"
            ? "true"
            : "false",
        platform: navigator.userAgent,
      });
    },

    // Used by pushmanager
    permissionChangeListener(permission) {
      console.log("permissions have changed", permission);
      // This only fires once the user has made a genuine grant/deny
      // decision on the real native browser dialog — not on a mere
      // Slidedown dismissal. That's exactly the signal we want to stop
      // re-asking on this device, and the first point where state is
      // actually settled enough to report.
      localStorage.setItem("push_prompt_shown", "true");
      this.pushDiagnosticTags();

      let data = {
        type: "open",
        message: `User has granted system-level push notification access.`,
      };
      window.events?.postAction(data);

      // permissionChange only tells us the OS-level decision — the
      // actual push token gets created in a separate step afterward,
      // which can take a moment. A near-immediate re-check here reads
      // token before it exists yet, which is why the toggle kept
      // showing optedIntoNotifications: false until a full page reload
      // gave it enough time to catch up. Give it real time instead.
      setTimeout(() => {
        window.notificationsSettings?.checkNotifications();
      }, 2500);
    },
    pushSubscriptionChangeListener(event) {
      console.log("push subscription change");
      console.log(event);
      if (event.current.token) {
        console.log("The push subscription has received a token!");
        // Redundant safety net alongside permissionChangeListener — a
        // real token only exists after a genuine grant, so this should
        // already be set by then, but this covers any edge case where
        // permissionChange doesn't fire but a token still shows up.
        localStorage.setItem("push_prompt_shown", "true");
        this.identifyUser();
        this.pushDiagnosticTags();

        // Pass the event's own confirmed values directly, rather than
        // having the settings panel re-read window.notifications.User.
        // PushSubscription live at this exact moment. That live object
        // can lag slightly behind what this event already reported,
        // which was causing the panel to show optedIn: true in its raw
        // osSettings dump while its own derived optedIntoNotifications
        // still read false.
        if (window.notificationsSettings?.applySubscriptionState) {
          window.notificationsSettings.applySubscriptionState(
            !!event.current.token,
            !!event.current.optedIn,
          );
        } else {
          window.notificationsSettings?.checkNotifications();
        }
      }
    },
    // Used by pushmanager
    optIn() {
      console.log("the user is opting in to notifications");
      this.$OneSignal.User.PushSubscription.optIn()
        .then(() => {
          console.log(
            "user is opted in?",
            this.$OneSignal.User.PushSubscription.optedIn,
          );
          window.notificationsSettings.checkNotifications();
          this.loginUser();
        })
        .catch((error) => {
          // Without this, a rejected promise here left PushManager.vue's
          // toggle stuck disabled indefinitely, since checkNotifications()
          // (the only thing that re-enables it) would never run.
          console.warn("*** app: optIn failed", error);
          window.notificationsSettings.checkNotifications();
        });
    },
    // Used by pushmanager
    optOut() {
      console.log("the user is opting out of notifications");
      this.$OneSignal.User.PushSubscription.optOut()
        .then(() => {
          console.log(
            "user is opted in?",
            this.$OneSignal.User.PushSubscription.optedIn,
          );
          window.notificationsSettings.checkNotifications();
        })
        .catch((error) => {
          console.warn("*** app: optOut failed", error);
          window.notificationsSettings.checkNotifications();
        });
    },
    async loginUser() {
      console.log("app.js: notifications: loggin in user");

      // Always safe — sets identity regardless of push state.
      this.identifyUser();

      // Only ever show the subscribe prompt once per device — on this
      // browser's first homescreen landing. Every previous attempt to
      // re-verify "is the user currently subscribed" on every landing
      // ran into unreliable signals specifically on iOS's
      // cold-launch-from-notification-click path (async hydration lag,
      // a WebKit Notification.permission bug, and a service worker
      // scope/click-relay dead end). Push subscription is inherently
      // tied to a device/browser, not a WP account, and a user only
      // ever needs to be asked once per device — so instead of
      // re-deriving live state every time, we just permanently remember
      // "have we already asked on this device." Nothing here can go
      // stale, because it's not claiming to be currently true, just
      // that it already happened once.
      if (localStorage.getItem("push_prompt_shown") === "true") {
        console.log(
          "loginUser: %cAlready asked on this device, skipping prompt.",
          "color:yellow;",
        );
        // Settled state — safe to report.
        this.pushDiagnosticTags();
        return;
      }

      if (Notification.permission === "denied") {
        // Already permanently blocked from a prior session — this is a
        // genuine decision already made, and the browser won't show the
        // native dialog again regardless, so mark it done.
        localStorage.setItem("push_prompt_shown", "true");
        console.log(
          "loginUser: %cNotification permissions are blocked.",
          "color:red;",
        );
        // Settled state (denied is final) — safe to report.
        this.pushDiagnosticTags();
      } else {
        // Deliberately NOT setting push_prompt_shown or calling
        // pushDiagnosticTags() here. If the user dismisses the Slidedown
        // without reaching the real native dialog, OneSignal has no
        // dedicated "dismissed" event to catch that — but
        // permissionChangeListener below only fires once a genuine
        // grant/deny decision is made at the OS level. So a mere
        // dismissal leaves this flag unset, and they'll be asked again
        // on their next login, exactly as intended. And since the
        // outcome is still pending here, there's nothing settled to
        // report yet — permissionChangeListener /
        // pushSubscriptionChangeListener push tags once it is.
        console.log(
          "loginUser: %cPushing prompt (first landing on this device).",
          "color:green;",
        );
        //this.$OneSignal.Notifications.requestPermission();
        this.$OneSignal.Slidedown.promptPush({
          force: true, // Makes it happen every time until they accept
        });

        // Push a baseline snapshot right away too — don't rely solely on
        // permissionChangeListener / pushSubscriptionChangeListener
        // firing below, since it's not confirmed those events reliably
        // fire for this exact Slidedown-triggered flow on every
        // browser/platform. Tags are cheap to overwrite and purely
        // informational (unlike the prompt-or-not decision this used to
        // also gate), so there's little downside to pushing early.
        this.pushDiagnosticTags();

        // Follow up once the user has had time to actually respond to
        // the native dialog and for a token to actually get created.
        // Fired later, this naturally lands after the early push (and
        // after anything the event listeners send) in practice, so it
        // self-corrects any stale snapshot — both the diagnostic tags
        // and PushManager.vue's own state — even if permissionChange /
        // the subscription change event never fire at all for this
        // browser.
        setTimeout(() => {
          this.pushDiagnosticTags();
          window.notificationsSettings?.checkNotifications();
        }, 8000);
      }
    },
  },
});
